




export const storecomponents = [

    {
        id:"1" ,
        image:"https://img-fotki.yandex.ru/get/5901/36902536.32/0_a7750_3cf305fa_XL.jpg",
        title:"Пастила из малины",
        description:"Состав: малина 90%, яблочное пюре 10%.",
        price:"Цена в тенге за 50гр:",
        money:"700"
    },

    {   id:"2" ,
        image:"https://vestikavkaza.ru/upload/2017-05-26/14958319325928957c751e99.10687412.jpg",
        title:"Пастила из яблок",
        description:"Состав: Яблочное пюре 100%",
        price:"Цена в тенге за 50гр:",
        money:"350"
    },

    {
        id:"3" ,
        image:"https://fruniksy.com/media/102/10203.jpg",
        title:"Пастила из клубники",
        description:"Состав: клубника 90% яблочное пюре 10%.",
        price:"Цена в тенге за 50гр:",
        money:"750"
    },

    {
        id:"4" ,
        image:"https://img-global.cpcdn.com/recipes/2abb29bb7a0458c0/680x482cq70/pastila-vishnia-banan-%D0%BE%D1%81%D0%BD%D0%BE%D0%B2%D0%BD%D0%BE%D0%B5-%D1%84%D0%BE%D1%82%D0%BE-%D1%80%D0%B5%D1%86%D0%B5%D0%BF%D1%82%D0%B0.jpg",
        title:"Пастила из вишни",
        description:"Состав: вишня 90%, яблочное пюре 10%.",
        price:"Цена в тенге за 50гр:",
        money:"700"
    },

    {
        id:"5" ,
        image:"https://nakormi.com/wp-content/uploads/2018/08/pastila-iz-persikov-600x450.jpg",
        title:"Пастила из персиков",
        description:"Состав: персики 90%, яблочное пюре 10%.",
        price:"Цена в тенге за 50гр:",
        money:"550"
    },

    {
        id:"6" ,
        image:"https://fruniksy.com/media/102/10242.jpg",
        title:"Пастила из сливы",
        description:"Состав: слива 90%, яблочное пюре 10%.",
        price:"Цена в тенге за 50гр:",
        money:"400"
    },

    {
        id:"7" ,
        image:"http://v.img.com.ua/b/600x500/6/70/20bfcf1caa9d755ff56c3d3dd5094706.jpg",
        title:"Сущенная малина",
        description:"Состав: малина 100%",
        price:"Цена в тенге за 50гр:",
        money:"650"
    },

    {
        id:"8" ,
        image:"https://static.1000.menu/img/content-v2/1b/cd/39288/vyalenye-pomidory-v-sushilke-dlya-ovoshchei-na-zimu_1569519824_1_max.jpg",
        title:"Вяленные помидоры",
        description:"Состав: помидоры, оливковое масло, специи.",
        price:"Цена в тенге за 250гр:",
        money:"1600"
    },

    {
        id:"9" ,
        image:"https://horoshieprivychki.ru/wp-content/uploads/2018/04/-%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%B0-%D0%B8-%D0%B2%D1%80%D0%B5%D0%B4-e1525000907967.jpg",
        title:"Сушенная клубника",
        description:"Состав: клубника 100%.",
        price:"Цена в тенге за 50гр:",
        money:"650"
    },

    {
        id:"10" ,
        image:"https://images.cdn.inmyroom.ru/inmyroom/thumb/620x398/jpg:85/uploads/food_recipe/teaser/26/26d1/jpg_1000_26d1da34-348a-4a32-80ba-071345bc2e2f.jpg?sign=8fc540180b97069881e4d1e90be7790f3fce9131dc53bdd317d8ff2d3d9452a3",
        title:"Чипсы из банана",
        description:"Состав: бананы 100% ",
        price:"Цена в тенге за 100гр:",
        money:"800"
    },

    {
        id:"11" ,
        image:"https://storage.myseldon.com/news_pict_E3/E3E53DDC38CAE32A2D8DBAC4761FC170",
        title:"Чипсы из персиков",
        description:"Состав: персики 100%",
        price:"Цена в тенге за 100гр:",
        money:"700"
    },
    {
        id:"12",
        image:"https://forexdengi.com/attachment.php?attachmentid=4636934&d=1614419504",
        title:"Чипсы из свеклы",
        description:"Состав: свекла 100%",
        price:"Цена в тенге за 100гр:",
        money:"300"
    },

   
];

export default storecomponents;